const BUILD_REFRESH_KEY = 'clas-build-refresh-id';

const getVersionUrl = () => {
  const url = new URL('/version.json', window.location.origin);
  url.searchParams.set('t', Date.now().toString());
  return url.toString();
};

const forceReloadForBuild = (buildId) => {
  const url = new URL(window.location.href);
  url.searchParams.set('v', buildId);
  window.location.replace(url.toString());
};

export const refreshIfStaleBuild = async () => {
  if (!import.meta.env.PROD) return;

  const currentBuildId = import.meta.env.VITE_APP_BUILD_ID;
  if (!currentBuildId) return;

  try {
    const response = await fetch(getVersionUrl(), { cache: 'no-store' });
    if (!response.ok) return;

    const latestVersion = await response.json();
    const latestBuildId = latestVersion?.buildId;
    const refreshedBuildId = window.sessionStorage.getItem(BUILD_REFRESH_KEY);

    if (latestBuildId && latestBuildId !== currentBuildId && refreshedBuildId !== latestBuildId) {
      window.sessionStorage.setItem(BUILD_REFRESH_KEY, latestBuildId);
      forceReloadForBuild(latestBuildId);
    }
  } catch {
    // Version checks should never block app startup.
  }
};
